export default __webpack_public_path__ + "static/media/planimages_84b.74edc0e5.png";